import { render } from "./HiModal.vue?vue&type=template&id=47f40404"
import script from "./HiModal.vue?vue&type=script&lang=js"
export * from "./HiModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__